import * as http from "api/http";

import {
  ReadLayerQuery,
  ReadLayerResult,
  ResultValue
} from "./readLayerService";
import { SERVICES_URL, handleError } from "api/helper";
import { PropertyService } from "@adfenix/types";

const get = http.get;
const post = http.post;

const baseAuthedV2 = "property/auth/v2";
const baseAuthedListing = "property/auth/v1/listing";

export const getPropertyById = (
  propertyId: string
): Promise<PropertyService.Property> =>
  get(`${SERVICES_URL}/${baseAuthedV2}/property/${propertyId}`);

export const updateListing = (propertyId: string): Promise<void> =>
  post(`${SERVICES_URL}/${baseAuthedListing}/update/${propertyId}`).catch(
    handleError
  );

export const updateGeoLocation = ({
  propertyId,
  geocoordinate
}: {
  propertyId?: string;
  geocoordinate: PropertyService.Geocoordinate | undefined;
}): Promise<void> =>
  post(
    `${SERVICES_URL}/${baseAuthedListing}/update-listing-geocoordinate/${propertyId}`,
    geocoordinate
  ).catch(handleError);

export const getListingDetails = (
  propertyId: string
): Promise<ReadLayerResult<PropertyService.PropertySearchModel>> =>
  post(`${SERVICES_URL}/property/auth/v1/read-layer/property/query/`, {
    filters: [{ column: "id", value: propertyId }],
    pageSize: 1
  });

export const reparseByQuery = (
  query: ReadLayerQuery
): Promise<ReadLayerResult<ResultValue>> =>
  post(`${SERVICES_URL}/property/auth/v1/read-layer/property/reparse/`, query);

export const propertyPublicInformation = ({
  propertyId
}: {
  propertyId: string;
}): Promise<PropertyService.PropertyPublicInformation> =>
  get(`${SERVICES_URL}/property/public/v1/property/${propertyId}`);
